import DataContext from "src/context/DataContext";
import { useContext } from "react";

const useData = () => useContext(DataContext);

export default useData;
